import RadioGroup from "@/components/RadioGroup/RadioGroup.tsx";
import { ParcelObjectType } from "@/helpers/types/types.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

export const ParcelObjectCategoryPicker = ({ cartItem }: { cartItem: CartAccommodationItem }) => {
  const { t } = useTranslation();
  const { setCartItemParcelObjectType } = useEngineStore(
    useShallow((state) => ({
      setCartItemParcelObjectType: state.setCartItemParcelObjectType,
    })),
  );

  useEffect(() => {
    setCartItemParcelObjectType(options[0]?.value, cartItem?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = [
    { value: ParcelObjectType.Camper, label: t("campSpecific.camper") },
    { value: ParcelObjectType.Tent, label: t("campSpecific.tent") },
    { value: ParcelObjectType.Caravan, label: t("campSpecific.caravan") },
  ];

  return (
    <RadioGroup
      options={options}
      onChange={(type) => setCartItemParcelObjectType(type as ParcelObjectType, cartItem?.id)}
      value={cartItem?.parcelObjectType}
    />
  );
};
